import React from 'react';
import { DataCollectionGapSummaryQuestionnaire } from '../../../../store/Models/Api/DataCollectionGapSummaryModels';
import { useLocalizer } from '../hooks/useLocalizer';
import QuestionnaireGapGroup from './QuestionnaireGapGroup';
import {
    getQuestionnaireRequiredQuestionUnanswered,
    hasQuestionnaireGaps
} from './helpers/gapSummaryHelpers';

interface SupplierLevelQuestionnaireProps {
    supplierQuestionnaires: DataCollectionGapSummaryQuestionnaire[];
    isExpanded: boolean;
    onToggle: () => void;
}

export const SupplierLevelQuestionnaire: React.FC<SupplierLevelQuestionnaireProps> = ({
    supplierQuestionnaires,
    isExpanded,
    onToggle
}) => {
    const localize = useLocalizer();
    const supplierQuestionnaireGaps = React.useMemo(() => {
        return supplierQuestionnaires.filter(hasQuestionnaireGaps);
    }, [supplierQuestionnaires]);

    const supplierRequiredQuestionUnanswered = React.useMemo(() => {
        return supplierQuestionnaireGaps.reduce(
            (total, questionnaire) => total + getQuestionnaireRequiredQuestionUnanswered(questionnaire),
            0);
    }, [supplierQuestionnaireGaps]);

    if (supplierRequiredQuestionUnanswered === 0) {
        return null;
    }

    return (
        <div className="gap-summary-question-row gap-summary-supplier-row">
            <button
                type="button"
                className="gap-summary-question-row-button gap-summary-supplier-row-button"
                onClick={onToggle}
                aria-expanded={isExpanded}
            >
                <span className={`glyphicon glyphicon-chevron-${isExpanded ? 'down' : 'right'}`} aria-hidden="true"></span>
                <span className="glyphicon glyphicon-list-alt gap-summary-supplier-row-icon" aria-hidden="true"></span>
                <span className="gap-summary-question-row-text">
                    <span className="gap-summary-question-row-name">{localize('supplier-level questions')}</span>
                    <span className="gap-summary-question-row-description">{localize('Questions about the supplier as a whole')}</span>
                </span>
                <span className="gap-summary-unanswered-pill">
                    {supplierRequiredQuestionUnanswered} {localize('Unanswered')}
                </span>
            </button>
            {isExpanded && (
                <div className="gap-summary-row-details gap-summary-supplier-details">
                    {supplierQuestionnaireGaps.map(questionnaire => (
                        <QuestionnaireGapGroup
                            key={questionnaire.id}
                            questionnaire={questionnaire}
                            showQuestionnaireName={false}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default SupplierLevelQuestionnaire;
